import styled from 'styled-components';

export const StyledInfo = styled.p`
  font-size: 1.125rem;
  margin-bottom: 0;
`;
